module.exports = __webpack_public_path__ + "static/media/image.cb544d7e.svg";